import React,{useEffect} from "react";
import AllProjectNavbar from "./AllProjectNavbar";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
} from "@mui/material";

import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ImageIcon from "@mui/icons-material/Image";
import InsightsIcon from "@mui/icons-material/Insights";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PublicIcon from "@mui/icons-material/Public";
import { TravelExplore } from "@mui/icons-material";
import { Col } from "react-bootstrap";
import { Link,  } from "react-router-dom";

const AllProjectDashboard = () => {
  useEffect(()=>{
    localStorage.removeItem("projectId");

  },[])
  const ProjectCards = [
    {
      icon: <DashboardCustomizeIcon fontSize="large" />,
      projectName:
        "UPDASP - Technology-Based Command Center for Crop Area and Yield Monitoring",
      url: "https://updasp.agrani.io",
      color: "#FF8A00",
    },
    {
      icon: <InsightsIcon fontSize="large" />,
      projectName: "Project MAATI - HCL Foundation",
      url: "/project/dashboard/cc5dc645-6e1e-4f4f-a476-4b87480dc5db",
      color: "#F2994A",
    },
    {
      icon: <AgricultureIcon fontSize="large" />,
      projectName:
        "Pilot Project on Direct Seeding of Rice (DSR) with Improved Water & Pest Management",
      // url: "/project/dashboard/54e529f7-f7e8-41a9-9f77-edb88fec7ea1",
      // url:"/project/dashboard/farmers-group/FPO/d986ef06-1cb6-4615-b853-e6874e40cd71",
      url:"project/dashboard/d986ef06-1cb6-4615-b853-e6874e40cd71",
      color: "#27AE60",
    },
    {
      icon: <LocalGroceryStoreIcon fontSize="large" />,
      projectName:
        "Pilot Project on Promotion of Vegetable Cluster and Development of a Sustainable Supply Chain to Boost Farmers Net Income",
      // url: "/project/dashboard/43bd693a-8890-4531-8e74-0f443893d70a",
      // url:"/project/dashboard/farmers-group/FPO/c31e207c-2474-4dbf-9230-4c33fc7c433e",
      url:"/project/dashboard/c31e207c-2474-4dbf-9230-4c33fc7c433e",
      color: "#E4D00A",
    },
    {
      icon: <AssessmentIcon fontSize="large" />,
      projectName: "Baseline Assessment for Value Chain",
      url: "/project/dashboard/abd091f2-1d89-465f-b35c-5d9bc2944a79",
      color: "#EB5757",
    },
    {
      icon: <PublicIcon fontSize="large" />,
      projectName:
        "360° Analytics of Olive Groves Value Chain – Portugal (Pilot Study)",
      url: "/project/dashboard/3e129491-515d-4fcb-9f36-4a42dfc7053d",
      color: "#6FCF97",
    },

    {
      icon: <ManageAccountsIcon fontSize="large" />,
      projectName: "DEVI - SAPTASHATI",
      url: "https://datapipeline.agrani.io/devi-saptashati",
      color: "#4A90E2",
    },

    {
      icon: <TravelExplore fontSize="large" />,
      projectName: "PixStack",
      url: "https://pixstack.ai/dashboard",
      color: "#9B51E0",
    },
  ];

  return (
    <Box sx={{ background: "", minHeight: "100vh" }}>
      <AllProjectNavbar />

      <div className="container-fluid p-5">
        <Grid container spacing={4}>
          {ProjectCards.map((item, i) => {
            const isExternal = item.url.startsWith("http");

            return (
              <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                <Card
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    height: "100%",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                    transition: "0.3s",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    borderTop: `3px solid ${item.color}`,
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  <CardContent sx={{ textAlign: "center" }}>
                    {React.cloneElement(item.icon, {
                      sx: { color: item.color },
                    })}

                    <Typography
                      variant="subtitle1"
                      sx={{ mt: 1.5, fontWeight: 600, minHeight: "48px" }}
                    >
                      {item.projectName}
                    </Typography>
                  </CardContent>

                  <div className="d-flex justify-content-center">
                    <Col lg="8">
                    {item.projectName==="Pilot Project on Direct Seeding of Rice (DSR) with Improved Water & Pest Management"
                    ?  <Link to={`/project/dashboard/d986ef06-1cb6-4615-b853-e6874e40cd71`}>
                                            <Button
                                              size="sm"
                                               variant="outlined"
                                             fullWidth
                                              sx={{
                          textTransform: "none",
                          borderRadius: 1,
                          marginBottom: 1,
                          fontWeight: 600,
                          color: item.color,
                          borderColor: item.color,

                          "&:hover": {
                            backgroundColor: item.color,
                            borderColor: item.color,
                            color: "white",
                          },
                        }}
                                            >
                                              View
                                            </Button>
                                          </Link>
                       :
                        item.projectName==="Pilot Project on Promotion of Vegetable Cluster and Development of a Sustainable Supply Chain to Boost Farmers Net Income"
                    ?  <Link to={`/project/dashboard/c31e207c-2474-4dbf-9230-4c33fc7c433e`}>
                                            <Button
                                              size="sm"
                                               variant="outlined"
                                               fullWidth
                                             
                                              sx={{
                          textTransform: "none",
                          borderRadius: 1,
                          marginBottom: 1,
                          fontWeight: 600,
                          color: item.color,
                          borderColor: item.color,

                          "&:hover": {
                            backgroundColor: item.color,
                            borderColor: item.color,
                            color: "white",
                          },
                        }}
                                            >
                                              View
                                            </Button>
                                          </Link>
                       :   item.projectName==="Project MAATI - HCL Foundation"
                    ?  <Link to={`/project/dashboard/cc5dc645-6e1e-4f4f-a476-4b87480dc5db`}>
                                            <Button
                                              size="sm"
                                               variant="outlined"
                                               fullWidth
                                             
                                              sx={{
                          textTransform: "none",
                          borderRadius: 1,
                          marginBottom: 1,
                          fontWeight: 600,
                          color: item.color,
                          borderColor: item.color,

                          "&:hover": {
                            backgroundColor: item.color,
                            borderColor: item.color,
                            color: "white",
                          },
                        }}
                                            >
                                              View
                                            </Button>
                                          </Link>
                       :<Button
                        variant="outlined"
                        href={item.url}
                        target={isExternal ? "_blank" : undefined}
                        fullWidth
                        sx={{
                          textTransform: "none",
                          borderRadius: 1,
                          marginBottom: 1,
                          fontWeight: 600,
                          color: item.color,
                          borderColor: item.color,

                          "&:hover": {
                            backgroundColor: item.color,
                            borderColor: item.color,
                            color: "white",
                          },
                        }}
                      >
                        View
                      </Button> 
          }
                    </Col>
                  </div>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </Box>
  );
};

export default AllProjectDashboard;
